// Calculate the subtotal from the service list
const calculateSubtotal = (serviceList) => {
  return serviceList.reduce(
    (sum, service) => sum + (service.show ? service.valor_cliente : 0),
    0
  );
};

// Calculate the subtotal for the client (what they effectively pay after reimbursement)
const calculateSubtotalCliente = (
  serviceList,
  modalidadePagamento,
  tipoCobertura
) => {
  if (
    tipoCobertura === "PARTICULAR" ||
    modalidadePagamento !== "REEMBOLSO_CLIENTE"
  ) {
    // For particular or direct payment, client pays what's shown in valor_cliente
    return calculateSubtotal(serviceList);
  }

  // For reimbursement, client pays total minus coverage
  const subtotalTotal = calculateSubtotal(serviceList);
  const totalCobertura = serviceList.reduce(
    (sum, service) => sum + (service.show ? service.valor_cobertura || 0 : 0),
    0
  );

  return subtotalTotal - totalCobertura;
};

// Calculate the total after applying the discount
const calculateTotal = (
  newSubtotal,
  subtotalCliente,
  discount,
  discountType,
  percentagemDescontoOriginal,
  majoracao,
  modalidadePagamento
) => {
  const majoracaoValue = Number(majoracao) || 0;
  const subtotalAposMajoracao = Math.round(newSubtotal - majoracaoValue);

  let valorDesconto = 0;

  if (discountType === "%") {
    // For percentage discount in reimbursement, apply over subtotalCliente
    if (modalidadePagamento === "REEMBOLSO_CLIENTE") {
      valorDesconto = Math.round(
        (subtotalCliente * percentagemDescontoOriginal) / 100
      );
    } else {
      // For direct payment or particular, apply over total
      valorDesconto = Math.round(
        (subtotalAposMajoracao * percentagemDescontoOriginal) / 100
      );
    }
  } else if (discountType === "$") {
    // For fixed amount discount, always apply the exact value
    valorDesconto = Number(discount) || 0;
  }

  return Math.round(subtotalAposMajoracao - valorDesconto);
};

// Main function to update all calculations
const updateCalculations = (
  serviceList,
  originalDiscount,
  discountType,
  percentagemDescontoOriginal,
  majoracao,
  modalidadePagamento = "DIRETO",
  tipoCobertura = "PARTICULAR"
) => {
  if (!serviceList || !Array.isArray(serviceList) || serviceList.length === 0) {
    console.error("Invalid serviceList:", serviceList);
    return { newSubtotal: 0, newTotal: 0, subtotalCliente: 0 };
  }

  const newSubtotal = calculateSubtotal(serviceList);
  const newSubtotalCliente = calculateSubtotalCliente(
    serviceList,
    modalidadePagamento,
    tipoCobertura
  );

  const newTotal = calculateTotal(
    newSubtotal,
    newSubtotalCliente,
    originalDiscount,
    discountType,
    percentagemDescontoOriginal,
    majoracao,
    modalidadePagamento
  );

  return {
    newSubtotal,
    newTotal,
    newSubtotalCliente,
  };
};

export {
  calculateSubtotal,
  calculateSubtotalCliente,
  calculateTotal,
  updateCalculations,
};
